$(document).ready(function() {
  var totalQtyReceived = 0;
  var totalQtyDispensed = 0;
  var total = 0;
  var lastProcessedDrugName = null;
  var stopUpdatingTotal = false;
  var data = []; // To store initial data
  
  // Function to populate the table with data
  function updateTable(filteredData) {
    if (jQuery.fn.dataTable.isDataTable('#datatbl')) {
      jQuery('#datatbl').DataTable().clear().destroy(); 
    }
    var tableBody = document.getElementById("tb");
    tableBody.innerHTML = ""; // Clear previous data
    
    filteredData.forEach(function(item) {
      var row = document.createElement("tr");
      
                      if (item.inv === "DISPENSING") {
                          
                            if (lastProcessedDrugName === item.drug_name) {
                              
                                stopUpdatingTotal = false;
                                totalQtyDispensed = 0;
                            } 
                            else if(lastProcessedDrugName !== item.drug_name){
                                // alert("First select its corresponding drug(Receving) to get BOH")
                              total=0;
                              totalQtyDispensed=0;
                              stopUpdatingTotal = true;
                            }
                          
                            if (!stopUpdatingTotal) {
                                var qtyDispensed = parseFloat(item.qty_dispensed) || 0;
                                totalQtyDispensed += qtyDispensed;
                                total = totalQtyReceived - totalQtyDispensed + (parseFloat(item.physical_count) || 0);
                              
                            }
                      }

      row.innerHTML = `
        <td style="border:1px solid black;">${item["drug_name"]}</td>
        <td style="border:1px solid black;">${item["drug_id"]}</td>
        <td style="border:1px solid black;">${item.patient_name}</td>
        <td style="border:1px solid black;">${item.rx}</td>
        <td style="border:1px solid black;">${item.qty_dispensed}</td>
        <td style="border:1px solid black;">${item.date_dispensed}</td>
        <td style="border:1px solid black;">${item.dispensed_by}</td>
        <td style="border:1px solid black;">${item.physical_count || 'N/A'}</td>
        <td class="boh" style="border:1px solid black;">${total}</td>
      `;
      tableBody.appendChild(row);
    });

    // Reinitialize DataTable after populating the table
    if (jQuery.fn.dataTable.isDataTable('#datatbl')) {
      jQuery('#datatbl').DataTable().clear().destroy(); // Destroy the existing DataTable instance
    }
    // Initialize the DataTable again after data is updated
        new DataTable('#datatbl', {
        layout: {
            topStart: {
                buttons: ['print']
            }
        }
    });
    
  }

  // Initial AJAX request to populate the table when the page loads
  $.ajax({
    url: "https://dev.redapplepharmacy.com/jotform/dispensing.php",  
    method: "POST",
    success: function(response) {
      data = JSON.parse(response); // Store the initial data
      updateTable(data); // Populate the table with initial data
    }
  });
  $('#startDate, #endDate').on('change', function() {
      var startDate = $('#startDate').val();
      var endDate = $('#endDate').val();
      if (startDate && endDate) {
        $('#applyFilter').prop('disabled', false);
      } else {
        $('#applyFilter').prop('disabled', true);
      }
    });
  // Apply date filter functionality
  $('#applyFilter').click(function() {
    var startDate = $('#startDate').val();
    var endDate = $('#endDate').val();

    $.ajax({
      url: "https://dev.redapplepharmacy.com/jotform/dates.php",  
      method: "POST",
      data: { startDate: startDate, endDate: endDate },
      success: function(response) {
        var filteredData = JSON.parse(response); 
        updateTable(filteredData); 
      },
      error: function(xhr, status, error) {
        console.log("Error:", error);
      }
    });
  });
});
